import type { ApiObject } from '@rudderstack/analytics-js'
import type { To } from 'react-router-dom'

import { rudderAnalytics } from '@/utils/rudderstack'

import {
  type IActivityTrackingService,
  type TrackingEvent,
  TrackingEvents,
} from './interfaces/IActivityTrackingService'

class ActivityTrackingService implements IActivityTrackingService {
  trackEvent(eventName: TrackingEvent, data?: ApiObject): Promise<void> {
    return new Promise((resolve) => {
      try {
        rudderAnalytics.track(eventName, data, () => {
          resolve()
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error tracking event:', error)
        resolve()
      }
    })
  }

  async trackUserLogin() {
    await this.trackEvent(TrackingEvents.login)
  }

  async trackUserLogout() {
    await this.trackEvent(TrackingEvents.logout)
  }

  async trackButtonClick(buttonId: string) {
    await this.trackEvent(TrackingEvents.menuBookings, {
      buttonId,
    })
  }

  async trackBookButtonClick(buttonId: string) {
    await this.trackEvent(TrackingEvents.bookTime, {
      buttonId,
    })
  }

  async trackRescheduleButtonClick(buttonId: string) {
    await this.trackEvent(TrackingEvents.rescheduleTime, {
      buttonId,
    })
  }

  async trackMenuNavigationClick(menuItem: To) {
    await this.trackEvent(TrackingEvents.menuBookings, {
      menuItem,
    })
  }

  async trackPhoneClick(phoneNumber: string) {
    await this.trackEvent(TrackingEvents.phoneClick, {
      phoneNumber,
    })
  }
}

const activityTrackingService = new ActivityTrackingService()
export { activityTrackingService }
